import React from "react";
import "./EconomyCab.css";
import { Link } from "react-router-dom";
import MarutiSwift from "../../assets/MarutiSwift.png";

import MarutiDzire from "../../assets/MarutiDzire.png";

import HyundaiXcent from "../../assets/HyundaiXcent.png";

import TataTigor from "../../assets/TataTigor.png";

import HondaAmaze from "../../assets/HondaAmaze.png";
import ToyotaEtios from "../../assets/ToyotaEtios.png";
import HyundaiSantro from "../../assets/HyundaiSantro.png";
import TataIndica from "../../assets/TataIndica.png";
import MarutiAlto from "../../assets/MarutiAlto.png";
import RenaultKwid from "..//../assets/RenaultKwid.png";
import HyundaiGrandi10 from "../../assets/HyundaiGrandi10.png";
import TataTiago from "../../assets/TataTiago.png";
import MarutiCelerio from "../../assets/MarutiCelerio.png";
import HyundaiAura from "../../assets/HyundaiAura.png";
import TataZest from "../../assets/TataZest.png";
import MarutiBaleno from "../../assets/MarutiBaleno.png";
import ToyotaGlanza from "../../assets/ToyotaGlanza.png";
import Hyundaii20 from "../../assets/Hyundaii20.png";
import TataPunch from "../../assets/TataPunch.png";
import MarutiWagonR from "../../assets/MarutiWagonR.png";


const economyCabData = [
  {
    id: 1,
    name: "Maruti Swift",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 190,
    image: MarutiSwift,
  },
  {
    id: 2,
    name: "Maruti Dzire",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1110,
    image: MarutiDzire,
  },
  {
    id: 3,
    name: "Hyundai Xcent",
    passenger: "4 Passenger",
    fuel: "CNG",
    price: 1100,
    image: HyundaiXcent,
  },
  {
    id: 4,
    name: "Tata Tigor",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1105,
    image: TataTigor,
  },
  {
    id: 5,
    name: "Honda Amaze",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1120,
    image: HondaAmaze,
  },
  {
    id: 6,
    name: "Toyota Etios",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1115,
    image: ToyotaEtios,
  },
  {
    id: 7,
    name: "Maruti WagonR",
    passenger: "4 Passenger",
    fuel: "CNG",
    price: 195,
    image: MarutiWagonR,
  },
  {
    id: 8,
    name: "Hyundai Santro",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 190,
    image: HyundaiSantro,
  },
  {
    id: 9,
    name: "Tata Indica",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1100,
    image: TataIndica,
  },
  {
    id: 10,
    name: "Maruti Alto",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price:  180,
    image: MarutiAlto,
  },
  {
    id: 11,
    name: "Renault Kwid",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 185,
    image: RenaultKwid,
  },
  {
    id: 12,
    name: "Hyundai Grand i10",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1110,
    image: HyundaiGrandi10,
  },
  {
    id: 13,
    name: "Tata Tiago",
    passenger: "4 Passenger",
    fuel: "CNG",
    price: 195,
    image: TataTiago,
  },
  {
    id: 14,
    name: "Maruti Celerio",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 190,
    image: MarutiCelerio,
  },
  {
    id: 15,
    name: "Hyundai Aura",
    passenger: "4 Passenger",
    fuel: "CNG",
    price: 1100,
    image: HyundaiAura,
  },
  {
    id: 16,
    name: "Tata Zest",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1115,
    image: TataZest,
  },
  {
    id: 17,
    name: "Maruti Baleno",
    passenger: "5 Passenger",
    fuel: "Petrol",
    price: 1130,
    image: MarutiBaleno,
  },
  {
    id: 18,
    name: "Toyota Glanza",
    passenger: "5 Passenger",
    fuel: "Petrol",
    price: 1135,
    image: ToyotaGlanza,
  },
  {
    id: 19,
    name: "Hyundai i20",
    passenger: "5 Passenger",
    fuel: "Diesel",
    price: 1140,
    image: Hyundaii20,
  },
  {
    id: 20,
    name: "Tata Punch",
    passenger: "5 Passenger",
    fuel: "Petrol",
    price: 1150,
    image: TataPunch,
  },
];
const EconomyCab = () => {
  return (
    <div className="economy-cab-main-container">
      {economyCabData.map((car) => (
        <Link
          to="/adventure-traveller-detail-page"
          className="economy-cab-link"
          state={{
            carData: car,
            totalPrice: car.price, // ✅ sending price
            pickup: "Your Location",
          }}
          key={car.id}
        > <div className="economy-cab-card" key={car.id}>
          {/* Fuel Tag */}
          <div className="economy-fuel-tag">{car.fuel}</div>

          {/* Price Tag */}
          <div className="economy-price-tag"> ₹{car.price}</div>

          {/* Image */}
          <div className="economy-cab-img-box">
            <img src={car.image} alt={car.name} />
          </div>

          {/* Content */}
          <div className="economy-cab-info">
            <h2>{car.name}</h2>
            <p>{car.passenger}</p>
          </div>
          </div>
          </Link>
      ))}
    </div>
  );
};

export default EconomyCab;
